import { render, staticRenderFns } from "./WebsiteAmenityCategoriesTable.vue?vue&type=template&id=40d83e9e&scoped=true&"
import script from "./WebsiteAmenityCategoriesTable.vue?vue&type=script&lang=js&"
export * from "./WebsiteAmenityCategoriesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d83e9e",
  null
  
)

export default component.exports